import { render } from "./PlanetMobile.vue?vue&type=template&id=1439f72b&scoped=true"
import script from "./PlanetMobile.vue?vue&type=script&lang=ts"
export * from "./PlanetMobile.vue?vue&type=script&lang=ts"

import "./PlanetMobile.vue?vue&type=style&index=0&id=1439f72b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1439f72b"

export default script